export const PRODUCTS_WAREHOUSE_STOCK = 'PRODUCTS_WAREHOUSE_STOCK';
export const PRODUCTS_WAREHOUSE_STOCK_CAUSES_LIST_KEY = 'PRODUCTS_WAREHOUSE_STOCK_CAUSES_LIST_KEY';
